const isContentValid = content => {
    if(!content) return true;
    switch (content.contentType) {
        case 'quiz':
            if (!content.questionBased.correctOptionSelected) return false;
            // fall through
        case 'poll':
            if (!content.questionBased.isTitleValid) return false;
            for (let contentId of Object.keys(content.questionBased.options)) {
                if (!content['questionBased']['options'][contentId]['isValid'] ||
                    content['questionBased']['options'][contentId]['isValid'] instanceof Object) return false;
            }
            return true;
        case 'story':
            return !!content.story.isTitleValid && !!content.story.isURLValid;

        default:
            return true;
    }
};

// const allContentsValid = contents => {
//     // console.log(contents)
//     for (let content of Object.values(contents)) {
//         if (!!!content.queuePosition) { continue; } // skip inactive content validation
//         if(!isContentValid(content)) { return false; }
//     }
//     return true;
// };

export { isContentValid };
